<template>
  <div class="flex items-center justify-center min-h-screen pb-24 bg-gray-100">
    <div
      class="flex flex-col p-4 bg-white rounded shadow w-128"
      @keyup.enter="handleSubmit"
    >
      <div
        class="p-4 mb-4 text-red-700 bg-red-100 border-l-4 border-red-500"
        v-if="loginerror"
        role="alert"
      >
        <p class="font-bold">Fel användarnamn/lösenord</p>
        <p>Försök igen.</p>
      </div>
      <div>
        <div class="w-full">
          <BaseInput v-model="username" label="Användarnamn" />
        </div>
        <div class="mt-3">
          <BaseInput v-model="password" label="Lösenord" type="password" />
        </div>
      </div>
      <div>
        <button
          @click="handleSubmit"
          class="w-full mt-4 btn btn-secondary"
          :disabled="loading"
        >
          Logga in
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      username: '',
      password: '',
      loginerror: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    async handleSubmit() {
      if (this.username != '' && this.password != '') {
        try {
          this.loading = true
          const {
            data: {
              login: { token },
            },
          } = await this.$apollo.mutate({
            mutation: gql`
              mutation login($data: LoginInput!) {
                login(data: $data) {
                  token
                }
              }
            `,
            variables: {
              data: {
                username: this.username,
                password: this.password,
              },
            },
          })
          if (token) await this.login(token)
        } catch (error) {
          this.loginerror = true
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
